import { freightTypeEnum } from '../hooks/freights/useConfigureFreight';
import { FreightStatus } from '../types/drawer.types';

/**
 * Business rules for freight editing based on freight type and status
 *
 * Rules:
 * - For autonomous/outsourced freights (PRIVATE/PUBLIC): Can edit only in specific statuses
 * - For in-house freights (INTERNAL): Can edit in all statuses except "Concluído"
 */

export const ALLOWED_STATUSES_FOR_AUTONOMOUS_FREIGHTS = [
  FreightStatus.AWAITING_DRIVER_ASSIGNMENT,
  FreightStatus.AWAITING_DRIVER_ACCEPTANCE,
  'Cancelamento solicitado',
  FreightStatus.READY_FOR_PICKUP,
];

export const FORBIDDEN_STATUS_FOR_INTERNAL_FREIGHTS = FreightStatus.COMPLETED;

/**
 * Checks if a freight can be edited based on its type and status
 * @param freightType - The type of freight (PRIVATE, PUBLIC, INTERNAL)
 * @param freightStatus - The current status of the freight
 * @returns true if editing is allowed, false otherwise
 */
export function canEditFreight(
  freightType: freightTypeEnum,
  freightStatus: string,
): boolean {
  // For autonomous/outsourced freights (PRIVATE/PUBLIC)
  if (
    freightType === freightTypeEnum.PRIVATE ||
    freightType === freightTypeEnum.PUBLIC
  ) {
    return ALLOWED_STATUSES_FOR_AUTONOMOUS_FREIGHTS.includes(freightStatus);
  }

  // For in-house freights (INTERNAL)
  if (freightType === freightTypeEnum.INTERNAL) {
    return freightStatus !== FORBIDDEN_STATUS_FOR_INTERNAL_FREIGHTS;
  }

  // Default: allow editing if type is not recognized
  return true;
}
